import { cloudFunction } from 'services/parse';

export const sendPushNotification = (data: Record<string, any>) => {
  return cloudFunction('sendPushNotification', data);
};

export const getNamedAudience = (data: Record<string,any>) =>{
  return cloudFunction('getNamedAudience',data);
};

export const sendPushNotificationByAudience = (data: Record<string,any>)=>{
  return cloudFunction('sendPushNotificationByAudience',data);
};